import { Outlet, useNavigate, useOutletContext } from 'react-router-dom'

import { Section } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import FormFieldsList from 'modules/expenses/components/FormFieldsList'
import {
  CustomizationField,
  fieldsFor,
  useExpensesCustomization,
} from 'modules/expenses/hooks/useExpensesCustomization'
import type { RouteContextParams } from 'modules/expenses/pages/settings/FormsCustomizationRootPage'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export const getTranslatedPageTitle = (resourceType: string) => {
  const types = {
    expense: i18n.t('expenses_v2.settings.forms.types.expense'),
    mileage: i18n.t('expenses_v2.settings.forms.types.mileage'),
    perdiem: i18n.t('expenses_v2.settings.forms.types.per_diem'),
  } as { [key: string]: string }

  return types[resourceType] || i18n.t('expenses_v2.settings.title')
}

const FormFieldsPage = () => {
  const routeContextParams = useOutletContext<RouteContextParams>()
  const resourceType = routeContextParams.resource_type
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { fields, error } = useExpensesCustomization()
  const resourceFields = fieldsFor(fields || [], resourceType)

  const onClickItemSettings = (field: CustomizationField) => {
    track(trackingEvents.expenses.goToExpensesFormFieldEdit, {
      expense_type: resourceType,
      field_name: field.identifier,
    })

    navigate(
      navigation.settings.expenses.expensesForms.fields.edit.fullPath({
        resource_type: resourceType,
        id: field.id,
      })
    )
  }

  return (
    <ResponsivePage.Body showHeader={false} loading={!fields} error={error}>
      <Section
        illustration="input-field"
        title={i18n.t('expenses_v2.settings.forms.fields_customization.title', {
          type: getTranslatedPageTitle(resourceType),
        })}
        description={i18n.t('expenses_v2.settings.forms.fields_customization.description', {
          type: getTranslatedPageTitle(resourceType).toLowerCase(),
        })}
      >
        <FormFieldsList fields={resourceFields} onClickItemSettings={onClickItemSettings} />
      </Section>
      <Outlet context={routeContextParams} />
    </ResponsivePage.Body>
  )
}

export default FormFieldsPage
